import { render, staticRenderFns } from "./KitchenMaterialReplacementForm.vue?vue&type=template&id=9264f8d0&"
import script from "./KitchenMaterialReplacementForm.vue?vue&type=script&lang=js&"
export * from "./KitchenMaterialReplacementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports